import { render, staticRenderFns } from "./BtnPrevent.vue?vue&type=template&id=1ee9ec04"
import script from "./BtnPrevent.vue?vue&type=script&lang=js"
export * from "./BtnPrevent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports